<section class="sana-auth auth-page">
  <div class="auth-card">
    <img
      src="/img/logo-without-slogan.png"
      alt="sanactivo"
      class="logo"
    />

    @if (!isSubmitted()) {
      <div class="step">
        <h2 class="title">Passwort zurücksetzen</h2>
        <p class="subtitle">Gib deine E-Mail-Adresse ein und wir schicken dir einen Link zum Zurücksetzen.</p>

        <form
          autocomplete="on"
          [formGroup]="passwordRequestForm"
          (ngSubmit)="onSubmit()">

          <label class="field">
            <span>E-Mail-Adresse</span>
            <input
              class="input"
              id="email"
              name="email"
              type="email"
              autocomplete="email"
              autofocus
              [class.is-invalid]="passwordRequestForm.controls.email.invalid && passwordRequestForm.controls.email.touched"
              [formControl]="passwordRequestForm.controls.email" />

            @if (passwordRequestForm.controls.email.invalid && passwordRequestForm.controls.email.touched) {
              <span class="field-error">Bitte gib eine gültige E-Mail-Adresse ein.</span>
            }
          </label>

          <div class="actions">
            <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
              {{ isSubmitting() ? 'Wird gesendet …' : 'Link senden' }}
            </button>
          </div>
        </form>
      </div>
    } @else {
      <div class="done-state">
        <div class="done-icon">✓</div>
        <h2 class="done-title">E-Mail unterwegs</h2>
        <p class="done-text">
          Wenn ein Konto mit dieser Adresse existiert, erhältst du in Kürze einen Link zum Zurücksetzen deines Passworts.
        </p>
        <button type="button" class="btn btn-secondary btn-inline resend" (click)="resend()">Erneut senden</button>
      </div>
    }

    <div class="auth-links centered">
      <a [routerLink]="['/login']">Zurück zur Anmeldung</a>
    </div>
  </div>

  <div class="auth-copyright">© {{ currentYear }} Sanactivo</div>
</section>
